// React
import { createContext } from "react"

export const ValidDateContext = createContext("")